import { render, staticRenderFns } from "./CollectDelDialog.vue?vue&type=template&id=9a5caac4&"
import script from "./CollectDelDialog.vue?vue&type=script&lang=js&"
export * from "./CollectDelDialog.vue?vue&type=script&lang=js&"
import style0 from "./CollectDelDialog.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a5caac4')) {
      api.createRecord('9a5caac4', component.options)
    } else {
      api.reload('9a5caac4', component.options)
    }
    module.hot.accept("./CollectDelDialog.vue?vue&type=template&id=9a5caac4&", function () {
      api.rerender('9a5caac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/collect/CollectDelDialog.vue"
export default component.exports